<div>
  <div class="column-100">
    <p>Odeslat požadavky na řádnou měsíční aktualizaci dat KN z aktivních projektů do PROMAPu (negeneruje XML žádost, pouze založí požadavky na data v PROMAPu).</p>
    <gmt-button [gmtDisabled]="!isValid()" [clickAction]="onSend">Provést</gmt-button>
  </div>
</div>
